import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Form as BForm, Card, Col, Row } from "react-bootstrap";
import crose from "../../../../../assets/images/icons/crose.svg";
import TextInput from "../../../../../components/formfields/InputField";
import AddTaskForm from "../../../../accountComplete/components/todo";
import "../style.scss";
import { getSecurityDataSelector } from "../../../../../store/selector/cmsSelector";
import addSecurityDataAction from "../actions";

const validationSchema = Yup.object({
  name: Yup.string().required("Name can not be empty"),
  excerpt: Yup.string().required("Excerpt can not be empty"),
});

function GeneralInfoSection() {
  const dispatch = useDispatch();
  const generalData = useSelector(getSecurityDataSelector);
  const [generalEdit, setGeneralEdit] = useState(false);

  const [keywords, setKeywords] = useState<any>([]);
  const addKeywords = (text: any) => setKeywords([...keywords, text]);
  const removeExpertise = (index: any) => {
    const newTasks = [...keywords];
    newTasks.splice(index, 1);
    setKeywords(newTasks);
  };

  const initialState = {
    name: generalData?.name ? generalData?.name : "",
    url: generalData?.url ? generalData?.url : "/security",
    excerpt: generalData?.excerpt ? generalData?.excerpt : "",
  };

  const handleSubmit = (values: any) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("excerpt", values.excerpt);
    formData.append("keywords", keywords);
    formData.append("request_type", "general");
    dispatch(addSecurityDataAction(formData, setGeneralEdit));
  };

  useEffect(() => {
    setKeywords(generalData?.keywords ? generalData?.keywords : []);
  }, [generalData?.keywords]);

  return (
    <Formik enableReinitialize initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ values, handleChange, handleBlur }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 ${generalEdit ? "editTitle" : ""}`}>General Info</h6>
                {generalEdit ? (
                  <button className="btn btn-primary" type="submit">
                    Save <i className="fa-regular fa-floppy-disk ms-1" />
                  </button>
                ) : (
                  <span className="btn btn-green" aria-hidden="true" onClick={() => setGeneralEdit(true)}>
                    Edit <i className="fa-regular fa-pen-to-square ms-1" />
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${generalEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                />
                <Row className="gy-3">
                  <Col xs={12}>
                    <Field
                      label="Name"
                      name="name"
                      component={TextInput}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Name"
                      readOnly={!generalEdit}
                      disabled={!generalEdit}
                      className={generalEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col xs={12}>
                    <BForm.Label className="form-label" htmlFor="url">
                      URL
                    </BForm.Label>
                    <BForm.Control name="url" type="text" id="url" value={values.url} placeholder="URL" readOnly disabled />
                  </Col>
                  <Col xs={12}>
                    <div className="multilineForm">
                      <BForm.Label className="form-label" htmlFor="excerpt">
                        Excerpt
                      </BForm.Label>
                      <BForm.Control
                        name="excerpt"
                        value={values.excerpt}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Excerpt"
                        readOnly={!generalEdit}
                        className={generalEdit ? "editField" : ""}
                        disabled={!generalEdit}
                      />
                      <ErrorMessage name="excerpt" className="errorMessage" component="div" />
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div className={`${generalEdit ? "editField" : ""}`}>
                      <label htmlFor="keywords">Keywords</label>
                      {generalEdit ? <AddTaskForm addTask={addKeywords} placeholder="Keywords" /> : ""}
                      <ul className="todo-list mt-0 gap-2 mt-3">
                        {keywords?.map((task: any, index: any) => (
                          <li key={task} className="todo m-0">
                            <span className="label">{task}</span>
                            {generalEdit ? (
                              <span aria-hidden="true" className="delete" onClick={() => removeExpertise(index)}>
                                <img src={crose} alt="delete" />
                              </span>
                            ) : (
                              ""
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default GeneralInfoSection;
